import React, { useEffect, useRef, useState } from "react";
import "./../../containers/Layout/Layout.css";
import { NotificationServices } from "../../../core/services/NotificationServices";
import {
  limitOfDataFromApi,
  dateFormat,
} from "../../../core/config/AppConstants";
import { createIconFont } from "@rsuite/icons";
import { Popover, Modal } from "rsuite";
import { useTranslation } from "react-i18next";
import moment from "moment/moment";
import { displayField } from "../../../utils/helpers";
const IconFont = createIconFont({
  scriptUrl: "//at.alicdn.com/t/font_2144422_r174s9i1orl.js",
  commonProps: { style: { fontSize: 30, color: "black" } },
  onLoaded: () => {
    console.log("onLoaded");
  },
});
const RecieveNotification = ({
  introLength = 50,
  ...props
}: {
  introLength?: number;
}) => {
  const { t } = useTranslation();
  const [notiCount, setNotiCount] = useState<any>();
  const [toggleDetailView, setToggleDetailView] = useState(false);
  const [notiDetailsForUser, setNotiDetailsForUser] = useState([]);
  const [notiDetailsForGroup, setNotiDetailsForGroup] = useState([]);
  const [notiDetailsForRole, setNotiDetailsForRole] = useState([]);
  const [readInDetail, setReadInDetail] = useState<any>();
  const notificationPupUp = useRef<any>();
  useOutsideAlerter(notificationPupUp);

  const fetchNotification = async (notiFor = "user", rows = 5) => {
    try {
      const res: any = await NotificationServices.recieveNotification(
        notiFor,
        rows
      );
      if (!notiFor || notiFor === t("USER").toLowerCase()) {
        setNotiDetailsForUser(res.data.data);
      }
      if (!notiFor || notiFor === t("GROUP").toLowerCase()) {
        setNotiDetailsForGroup(res.data.data);
      }
      if (!notiFor || notiFor === t("ROLE").toLowerCase()) {
        setNotiDetailsForRole(res.data.data);
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  const newNotoficationCount = async () => {
    try {
      const res: any = await NotificationServices.newNotificationCount();
      setNotiCount(res?.data);
    } catch (error: any) {
      console.log(error);
    }
  };

  const readNotification = async (readIds: string) => {
    try {
      const res: any = await NotificationServices.readNotification(readIds);
    } catch (error: any) {
      console.log(error);
    }
  };

  const handleNoti = () => {
    setToggleDetailView(!toggleDetailView);
    fetchNotification("user", limitOfDataFromApi.forUsers);
    fetchNotification("group", limitOfDataFromApi.forGroup);
    fetchNotification("role", limitOfDataFromApi.forRoles);
  };

  useEffect(() => {
    newNotoficationCount();
  }, []);

  //This solution of using event listner is veryfied by stack overflow hence used
  function useOutsideAlerter(ref: any) {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setToggleDetailView(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [notificationPupUp]);
  }

  const calculateSentNotiTime = (dateSent: Date) => {
    let today = new Date();
    let sentAt = moment.utc(dateSent).local().format();
    let dateShow: any = "Just Now";
    let year = moment(today).diff(sentAt, "years");
    if (year) {
      dateShow = year + `${year && year > 1 ? " years" : " year"}` + " ago";
      return dateShow;
    }
    let months = moment(today).diff(sentAt, "months");
    if (months) {
      dateShow =
        months + `${months && months > 1 ? " months" : " month"}` + " ago";
      return dateShow;
    }
    let days = moment(today).diff(sentAt, "days");
    if (days) {
      dateShow = days + `${days && days > 1 ? " days" : " day"}` + " ago";
      return dateShow;
    }
    let hours = moment(today).diff(sentAt, "hours");
    if (hours) {
      dateShow = hours + `${hours && hours > 1 ? " hours" : " hour"}` + " ago";
      return dateShow;
    }
    let minutes = moment(today).diff(sentAt, "minutes");
    if (minutes) {
      dateShow =
        minutes + `${minutes && minutes > 1 ? " minutes" : " minute"}` + " ago";
      return dateShow;
    }
    return dateShow;
  };

  return (
    <>
      <div className="notification-count" onClick={(e) => handleNoti()}>
        <IconFont icon="rs-iconnotice" rotate={0} />
        {notiCount?.total ? (
          <span>{notiCount?.total > 0 ? notiCount?.total : ""}</span>
        ) : null}
      </div>
      {toggleDetailView && (
        <div className="notification-fixed-box" ref={notificationPupUp}>
          <Popover className="notification-scroll" title="Notification" visible>
            <hr className="mt-1 mb-1" />
            {notiDetailsForUser?.length ? (
              <>
                <label className="ntfy-usr-lbl">
                  {t("USER").toLowerCase()}{" "}
                  {"(" + notiCount?.data?.for_me + ")"}
                </label>
                {notiDetailsForUser.map((item: any, index: number) => {
                  return (
                    <div
                      key={index}
                      className={
                        item.read_at
                          ? "noti-box mt-2"
                          : "noti-box noti-box-unread mt-2"
                      }
                    >
                      {item && item?.title && (
                        <div
                          className="noti-detail"
                          onClick={(e) => {
                            readNotification(item.id);
                            setReadInDetail(item);
                          }}
                        >
                          <h5
                            className={
                              item.read_at
                                ? "read-normal read-bold"
                                : "read-bold"
                            }
                          >
                            {item.title}
                          </h5>
                          <div>
                            <p
                              className={
                                item.read_at
                                  ? "read-normal read-bold"
                                  : "read-bold"
                              }
                            >
                              {displayField(
                                item.notification.substring(0, introLength)
                              )}{" "}
                              {item.notification.length > introLength
                                ? "..."
                                : null}
                            </p>
                            {item && item.created_at && item.created_by_name ? (
                              <p
                                className="sent-by"
                                title={`${
                                  "Sent At : " +
                                  moment
                                    .utc(item?.created_at)
                                    .local()
                                    .format(
                                      dateFormat.dateFormatForNotification +
                                        ", h:mm:ss a"
                                    )
                                }`}
                              >
                                <b>Sent By :</b> {item?.created_by_name}, <br />{" "}
                                <i>{calculateSentNotiTime(item?.created_at)}</i>
                              </p>
                            ) : null}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </>
            ) : null}
            {notiDetailsForGroup?.length ? (
              <>
                <label className="ntfy-usr-lbl">
                  {t("GROUP").toLowerCase()}{" "}
                  {"(" + notiCount?.data?.for_my_group + ")"}
                </label>
                {notiDetailsForGroup?.length &&
                  notiDetailsForGroup.map((item: any, index: number) => {
                    return (
                      <div key={index} className="noti-box">
                        {item && item?.title && (
                          <div
                            className="noti-detail"
                            onClick={(e) => {
                              readNotification(item.id);
                              setReadInDetail(item);
                            }}
                          >
                            <p
                              className={
                                item.read_at
                                  ? "read-normal read-bold"
                                  : "read-bold"
                              }
                            >
                              {item.title}
                            </p>
                            <p
                              className={
                                item.read_at
                                  ? "read-normal read-bold"
                                  : "read-bold"
                              }
                              title={item.notification}
                            >
                              {item.notification}
                            </p>
                            {item && item.created_at && item.created_by_name ? (
                              <p
                                className="sent-by"
                                title={`${
                                  "Sent At : " +
                                  moment
                                    .utc(item?.created_at)
                                    .local()
                                    .format(
                                      dateFormat.dateFormatForNotification +
                                        ", h:mm:ss a"
                                    )
                                }`}
                              >
                                Sent By : {item?.created_by_name},{" "}
                                <strong>
                                  {calculateSentNotiTime(item?.created_at)}
                                </strong>
                              </p>
                            ) : null}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </>
            ) : null}

            {notiDetailsForRole?.length ? (
              <>
                <label className="ntfy-usr-lbl">
                  {t("ROLE").toLowerCase()}{" "}
                  {"(" + notiCount?.data?.for_my_role + ")"}
                </label>
                {notiDetailsForRole?.length &&
                  notiDetailsForRole.map((item: any, index: number) => {
                    return (
                      <div key={index} className="noti-box">
                        {item && item?.title && (
                          <div
                            className="noti-detail"
                            onClick={(e) => {
                              readNotification(item.id);
                              setReadInDetail(item);
                            }}
                          >
                            <p
                              className={
                                item.read_at
                                  ? "read-normal read-bold"
                                  : "read-bold"
                              }
                            >
                              {item.title}
                            </p>
                            <p
                              className={
                                item.read_at
                                  ? "read-normal read-bold"
                                  : "read-bold"
                              }
                            >
                              {item.notification}
                            </p>
                            {item && item.created_at && item.created_by_name ? (
                              <p
                                className="sent-by"
                                title={`${
                                  "Sent At : " +
                                  moment
                                    .utc(item?.created_at)
                                    .local()
                                    .format(
                                      dateFormat.dateFormatForNotification +
                                        ", h:mm:ss a"
                                    )
                                }`}
                              >
                                Sent By : {item?.created_by_name},{" "}
                                <strong>
                                  {calculateSentNotiTime(item?.created_at)}
                                </strong>
                              </p>
                            ) : null}
                          </div>
                        )}
                      </div>
                    );
                  })}
              </>
            ) : null}
            {!notiDetailsForUser?.length &&
            !notiDetailsForGroup?.length &&
            !notiDetailsForRole?.length ? (
              <p style={{ textAlign: "center" }}>{t("NO_NOTIFICATION")}</p>
            ) : null}
          </Popover>
        </div>
      )}
      <Modal
        open={readInDetail ? true : false}
        backdrop="static"
        className="ntfy-mdl"
        onClose={(e: any) => {
          setReadInDetail("");
        }}
      >
        <Modal.Header className="pt-2 pb-2 mb-2">
        <h6>Title : {readInDetail?.title}</h6>
        </Modal.Header>
        <Modal.Body className="pb-0">
          <div className="notiDetailPopup">
            <p>{readInDetail?.notification}</p>
            <p>
              Sent By : {readInDetail?.created_by_name},
              {`${
                " Sent At : " +
                moment
                  .utc(readInDetail?.created_at)
                  .local()
                  .format(dateFormat.dateFormatForNotification + ", h:mm:ss a")
              }`}
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RecieveNotification;
